// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// CREDENTIALS SCHEMA
/////////////////////////////////////////

export const CredentialsSchema = z.object({
  personalTokenEnc: z.string().nullable(),
  gitHubInstallationId: z.string().nullable(),
  gitHubAppId: z.string().nullable(),
  gitHubAppPrivateKeyEnc: z.string().nullable(),
  gitLabUserCredentialId: z.string().nullable(),
  azureDevOpsUserCredentialId: z.string().nullable(),
})

export type Credentials = z.infer<typeof CredentialsSchema>

export default CredentialsSchema;
